import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import Qualendar from '../components/Qualendar';
import './Home.css';
import { entries } from '../data';

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="ion-text-center">Mutmacher Qualender</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Mutmacher Qualender</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Qualendar />
      </IonContent>
    </IonPage>
  );
};

export default Home;
